export const getPreselectedDealers = (dealerList) => {
  return Object.keys(dealerList).reduce((acc, index) => {
    if (index < 3) {
      acc.push(dealerList[index]);
    }
    return acc;
  }, []);
};
